import {AnalyzerChatItemProps, ChatItemType} from "@/pages/analyzer/Analyzer.types.ts";
import {AnalyzerChatMessage} from "@/pages/analyzer/components/chat/AnalyzerChatMessage.tsx";
import {AnalyzerOptionalSettings} from "@/pages/analyzer/components/chat/AnalyzerOptionalSettings.tsx";
import {AnalyzerPollAnswerChip} from "@/pages/analyzer/components/chat/AnalyzerPollAnswerChip.tsx";
import {AnalyzerPollCard} from "@/pages/analyzer/components/chat/AnalyzerPollCard.tsx";
import {AnalyzerRetryAlert} from "@/pages/analyzer/components/chat/AnalyzerRetryAlert.tsx";
import {AnalyzerRevisionNotice} from "@/pages/analyzer/components/chat/AnalyzerRevisionNotice.tsx";
import {AnalyzerToolGroup} from "@/pages/analyzer/components/chat/AnalyzerToolGroup.tsx";
import {AnalyzerUserMessage} from "@/pages/analyzer/components/chat/AnalyzerUserMessage.tsx";

export const AnalyzerChatItem = ({item, isLast, className}: AnalyzerChatItemProps) => {
  switch (item.type) {
    case ChatItemType.MESSAGE:
      return <AnalyzerChatMessage content={item.event.content} className={className} />;
    case ChatItemType.USER_MESSAGE:
      return <AnalyzerUserMessage content={item.content} className={className} />;
    case ChatItemType.TOOL_GROUP:
      return <AnalyzerToolGroup item={item} isLast={isLast} className={className} />;
    case ChatItemType.POLL:
      return <AnalyzerPollCard event={item.event} className={className} />;
    case ChatItemType.ANSWER_CHIP:
      return (
        <AnalyzerPollAnswerChip
          event={item.event}
          answer={item.answer}
          superseded={item.superseded}
          className={className}
        />
      );
    case ChatItemType.NOTICE:
      return (
        <AnalyzerRevisionNotice success={item.success} callout={item.callout} body={item.body} className={className} />
      );
    case ChatItemType.SETTINGS:
      return <AnalyzerOptionalSettings className={className} />;
    case ChatItemType.ERROR:
      return (
        <AnalyzerRetryAlert callout="Analysis failed" retryable={isLast} className={className}>
          {item.message}
        </AnalyzerRetryAlert>
      );
  }
};
